module.exports = __webpack_public_path__ + "static/media/MissFortune.d346c5cb.png";